import { appHelpers } from '../_helpers';
import axios from "axios/index";
import {appConstants} from "../_constants";

export const apiService = {
    post,
    get,
    interpretErrorResponse
};

function post(payload, url__) {

    let payloadStringify = JSON.stringify(payload);

    let activeUser = appHelpers.getActiveUser();
    let reqHeader = {'Content-Type': 'application/json', 'AppName' : appConstants.APP_ID};
    if(activeUser)
        reqHeader.Authorization = 'bearer' + activeUser.access_token;

    let config = {headers: reqHeader};
    return axios.post(url__, payloadStringify, config);
}

function interpretErrorResponse(error) {
     let errorMessage = '';
    if(error.response === undefined){
        errorMessage = 'Please, check your internet connectivity!';
    }else{
        errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';
    }
    if(typeof errorMessage === 'string'){
        return errorMessage
    }else{
        return "Something went wrong!";
    }
}
function get(url) {
    let activeUser = appHelpers.getActiveUser();
    let reqHeader = {'Content-Type': 'application/json', 'AppName' : appConstants.APP_ID};
    if(activeUser)
        reqHeader.Authorization = 'bearer' + activeUser.access_token;

    let config = {headers: reqHeader};
    return axios.get(url, config);
}


// WEBPACK FOOTER //
// ./src/_services/api.service.js